module.exports = __webpack_public_path__ + "static/media/viewDocument.f136f6f9.svg";